import { appConfig } from 'appConfig'

// Cookies
export const QUIZ_ID_COOKIE_NAME = 'cUserId'
export const QUIZ_VERSION_COOKIE_NAME = 'cQuizVersion'
export const QUIZ_EMAIL_COOKIE_NAME = 'cUserEmail'
// NOT cGeoIpCountry — that name is owned by zoe-website's middleware, and writing it with Domain=.zoe.com shadowed it.
export const QUIZ_COUNTRY_COOKIE_NAME = 'cQuizCountry'
export const QUIZ_COMPLETE_COOKIE_NAME = 'cQuizComplete'

export const STAGE_COOKIE_DOMAIN = process.env.STAGE_COOKIE_DOMAIN || 'stage.joinzoe.com'
export const STAGE_COOKIE_DOMAIN_ZOE = '.stage.zoe.com'
export const PROD_COOKIE_DOMAIN_JOINZOE = '.joinzoe.com'
export const PROD_COOKIE_DOMAIN = '.zoe.com'

export const COOKIE_DOMAIN_MAP = {
  localhost: 'localhost',
  'joinzoe.com': PROD_COOKIE_DOMAIN_JOINZOE,
  'my.joinzoe.com': PROD_COOKIE_DOMAIN_JOINZOE,
  'quiz.joinzoe.com': PROD_COOKIE_DOMAIN_JOINZOE,
  'bluepoop.joinzoe.com': PROD_COOKIE_DOMAIN_JOINZOE,
  'zoe.com': PROD_COOKIE_DOMAIN,
  'my.zoe.com': PROD_COOKIE_DOMAIN,
  'quiz.zoe.com': PROD_COOKIE_DOMAIN,
  'bluepoop.zoe.com': PROD_COOKIE_DOMAIN,
}

export const cookieDomainForHost = (hostname: string): string => {
  const mapped = COOKIE_DOMAIN_MAP[hostname as keyof typeof COOKIE_DOMAIN_MAP]
  if (mapped) return mapped
  if (hostname === 'stage.zoe.com' || hostname.endsWith('.stage.zoe.com')) return STAGE_COOKIE_DOMAIN_ZOE

  return STAGE_COOKIE_DOMAIN
}

export const SECONDS_IN_A_DAY = 86400
export const FOUR_YEARS_IN_SECONDS = (4 * 365 + 1) * SECONDS_IN_A_DAY

export const QUIZ_ID_COOKIE_EXPIRY_DAYS = 30

export const DEFAULT_COOKIE_OPTIONS = {
  path: '/',
  maxAge: FOUR_YEARS_IN_SECONDS,
}

// Exit urls
export const GB_EXIT_PATH = `${appConfig.zoeWebsiteBaseUri}/buymembership/plans`
export const US_EXIT_PATH = `${appConfig.zoeWebsiteBaseUri}/buymembership/plans`
export const GUEST_PASS_EXIT_PATH = `${appConfig.zoeWebsiteBaseUri}/en-gb/buymembership/checkout-guest-pass`
